/*=========================================================================================
  File Name: moduleCustomer.js
  Description: Customer Module
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import state from './moduleKitchenStocksState.js'
import mutations from './moduleKitchenStocksMutations.js'
import actions from './moduleKitchenStocksActions'
import getters from './moduleKitchenStocksGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}